import React, { useEffect, useState, useRef } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Icon from "@material-ui/core/Icon";
import ArrowBack from "@material-ui/icons/ArrowBack";
import CardContent from "@mui/joy/CardContent";
import MotorhomeIcon from "components/CustomIcons/Motorhome.js";
import PhoneIcon from "components/CustomIcons/Phone.js";
import EmailIcon from "components/CustomIcons/Email.js";
import ViewIcon from "components/CustomIcons/View.js";
import DownloadIcon from "components/CustomIcons/Download.js";
import StoreIcon from "components/CustomIcons/Store.js";
import Wizard from "components/Wizard/WizardRedesign.js";
import {
  Timeline,
  TimelineItem,
  TimelineSeparator,
  TimelineDot,
  TimelineConnector,
  TimelineContent,
  TimelineOppositeContent,
} from "@mui/lab";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import { Box } from "@mui/material";
import Step1 from "../Forms/WizardSteps/Step1";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import Person from "@material-ui/icons/Person";
import Edit from "@material-ui/icons/Edit";
import Close from "@material-ui/icons/Close";
import Check from "@material-ui/icons/Check";
import Remove from "@material-ui/icons/Remove";
import Add from "@material-ui/icons/Add";
import KeyboardArrowRight from "@material-ui/icons/KeyboardArrowRight";

// @material-ui/icons
import AllInbox from "@material-ui/icons/AllInbox";
import Apps from "@material-ui/icons/Apps";
import Store from "@material-ui/icons/Store";
import Warning from "@material-ui/icons/Warning";
import Place from "@material-ui/icons/Place";

import Email from "@material-ui/icons/Email";
import WhatsApp from "@material-ui/icons/WhatsApp";
import Phone from "@material-ui/icons/Phone";
import Download from "@material-ui/icons/CloudDownload";

import { useInactivity } from "components/Inactivity/Inactivity";

// core components
import GridContainer from "components/Grid/GridContainer.js";
import PaginatedPoliciesMobile from "components/Policies/PaginatedPoliciesMobile.js";
import PaginatedPoliciesAgent from "components/Policies/PaginatedPoliciesMobileAgentHome.js";
import GridItem from "components/Grid/GridItem.js";
import Table from "components/Table/CustomTable.js";
import Button from "components/CustomButtons/CustomButton";
import Danger from "components/Typography/Danger.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardIcon from "components/Card/CardIcon.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import PolicyCard from "@material-ui/icons/CardMembership";
import stylePrincipal from "assets/jss/material-dashboard-pro-react/components/principalStyle.js";
import CustomResource from "components/CustomResource/CustomResource";
import StepperComponent from "components/Stepper/StepperComponent";

import styles from "assets/jss/material-dashboard-pro-react/views/loginPageStyle.js";
import wizardStyle from "assets/jss/material-dashboard-pro-react/components/wizardStyle.js";

import {
  getOrdersByClient,
  getExpiringOrdersAgency,
  getDataGraph,
  getDataNews,
  getActiveOrdersByClient,
  getAgencyDataByClient,
  getQuotesByClient,
} from "views/Services/OrdersService";
import { formatNumber } from "components/Utils/utils.js";

import {
  buttonStyleStatusPolicy,
  checkIfIsKiosko,
  isAgent,
} from "components/Utils/utils.js";
import environment from "../../environment/environment";
import { Assignment } from "@material-ui/icons";
import { useTranslation } from "react-i18next";
const server = `${environment.SERVER}`;

const useStyles = makeStyles(styles);
const useStylesPrincipal = makeStyles(stylePrincipal);
export default function Dashboard() {
  const wizardRef = useRef(null);
  const { t, i18n } = useTranslation();
  const classesPrincipal = useStylesPrincipal();
  let USDollar = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  });
  const isKiosko = checkIfIsKiosko();
  const history = useHistory();
  const dispatch = useDispatch();
  const [ordersExpiring, setOrdersExpiring] = useState([]);
  const [orders, setOrders] = useState([]);
  const [ordenes, setOrdenes] = useState([]);
  const [quotes, setQuotes] = useState([]);
  const [agencyData, setAgencyData] = useState(null);
  const isInactive = useInactivity();
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.only("xs"));
  const isSm = useMediaQuery(theme.breakpoints.only("sm"));
  const isMd = useMediaQuery(theme.breakpoints.only("md"));
  const isLg = useMediaQuery(theme.breakpoints.only("lg"));
  const isXl = useMediaQuery(theme.breakpoints.only("xl"));
  const [activeStep, setActiveStep] = useState(0);
  const [dataMonth, setDataMonth] = useState([]);
  const [dataYear, setDataYear] = useState([]);
  const [news, setNews] = useState([]);

  const cardStyleExpire = {
    border: "2px solid #F44336",
  };
  const cardStyleWarning = {
    border: "2px solid #FF9802",
  };
  const cardStyleSuccess = {
    border: "2px solid #4CAF50",
  };
  useEffect(() => {
    if (isAgent) {
      getExpiringOrders();
      getDataGraphAgent("month");
      getDataGraphAgent("year");
      getNewsHome();
    } else {
      getOrders();
      getActiveOrders();
      getAgencyData();
      getQuotes();
    }
  }, [dispatch]);

  useEffect(() => {
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      window.dataLayer.push(arguments);
    }

    gtag("consent", "default", {
      ad_storage: "denied",
      analytics_storage: "denied",
      ad_user_data: "denied",
      ad_personalization: "denied",
      personalization_storage: "denied",
      functionality_storage: "granted",
      security_storage: "granted",
      wait_for_update: 500,
    });

    gtag("set", "ads_data_redaction", true);
  }, []);

  const getQuotes = async () => {
    const resultSubmit = await dispatch(getQuotesByClient({}));
    setQuotes(resultSubmit.payload.data);
  };
  const getOrders = async () => {
    const resultSubmit = await dispatch(getOrdersByClient());
    setOrdenes(resultSubmit.payload.data);
  };
  const getExpiringOrders = async () => {
    const resultSubmit = await dispatch(getExpiringOrdersAgency());
    if (resultSubmit.payload.data.length > 0) {
      let ordersExpiringData = [];
      resultSubmit.payload.data.forEach((order) => {
        ordersExpiringData.push([
          {
            name: order.policy_nbr,
            type: "url",
            url: `/guest/summary/policy/${order.id}`,
          },
          {
            name: order.customer_name,
            className: isXs || isSm || isMd ? classes.displayNone : "",
          },
          order.expiration_date,
          {
            name: order.policy_type,
            className: isXs || isSm || isMd ? classes.displayNone : "",
          },
        ]);
      });
      setOrdersExpiring(ordersExpiringData);
    }
  };
  const getNewsHome = async () => {
    const resultSubmit = await dispatch(getDataNews({}));
    setNews(resultSubmit.payload.data);
  };
  const getDataGraphAgent = async (type) => {
    const resultSubmit = await dispatch(getDataGraph({ type: type }));
    setDataGraph(resultSubmit.payload, type);
  };
  const setDataGraph = (data, type) => {
    let monthList = {
      1: "January",
      2: "February",
      3: "March",
      4: "April",
      5: "May",
      6: "June",
      7: "July",
      8: "August",
      9: "September",
      10: "October",
      11: "November",
      12: "December",
    };
    let currentTime = new Date();
    let monthCurrent = monthList[currentTime.getMonth() + 1];
    let yearCurrent = currentTime.getFullYear();
    let yearPrevious = yearCurrent - 1;

    let dataJson = [
      {
        name: monthCurrent + " " + yearPrevious,
        policyCount: data.totalPoliciesCountPrevious,
        netPremium: parseFloat(data.totalPoliciesAmountPrevious),
      },
      {
        name: monthCurrent + " " + yearCurrent,
        policyCount: data.totalPoliciesCountCurrent,
        netPremium: parseFloat(data.totalPoliciesAmountCurrent),
      },
    ];
    if (type == "year") {
      dataJson[0].name = yearPrevious;
      dataJson[1].name = yearCurrent;
    }
    type == "month" ? setDataMonth(dataJson) : setDataYear(dataJson);
  };
  const calculateExpirationText = (orderExpirationDate) => {
    if (orderExpirationDate != null && orderExpirationDate != "") {
      let newDateExpiration = orderExpirationDate.split("-");
      const fechaActual = new Date();
      const fechaExpiracion = new Date(
        newDateExpiration[2] +
          "-" +
          newDateExpiration[0] +
          "-" +
          newDateExpiration[1]
      );
      const diferenciaMilisegundos = fechaExpiracion - fechaActual;
      const diferenciaDias = diferenciaMilisegundos / (1000 * 60 * 60 * 24);
      if (diferenciaDias < 0) {
        return "Expired";
      } else {
        return "Active";
      }
    }
  };
  const calculateExpirationDays = (orderExpirationDate) => {
    if (orderExpirationDate != null && orderExpirationDate != "") {
      const fechaActual = new Date();
      const fechaExpiracion = new Date(orderExpirationDate);
      const diferenciaMilisegundos = fechaExpiracion - fechaActual;
      const diferenciaDias = diferenciaMilisegundos / (1000 * 60 * 60 * 24);
      return parseInt(diferenciaDias);
    }
    return 0;
  };

  const fillButtons = (order) => {
    return (
      <>
        <GridContainer>
          <GridItem
            onClick={() => history.push(`/guest/summary/${order.order_id}`)}
            md={6}
          >
            <ViewIcon></ViewIcon>
          </GridItem>
          <GridItem
            onClick={() => {
              window.open(`/admin/policyPdf/policy/${order.policy_nbr}`);
            }}
            md={6}
          >
            <DownloadIcon></DownloadIcon>
          </GridItem>
        </GridContainer>
      </>
    );
  };
  const completeQuote = (order) => {
    return (
      <>
        <GridContainer>
          <GridItem
            onClick={() => history.push(`/guest/en/${order.id}`)}
            md={6}
          >
            <ViewIcon></ViewIcon>
          </GridItem>
        </GridContainer>
      </>
    );
  };

  const getMakeModelName = (order, type) => {
    return ["1", "5"].includes(order.vehicle_type_id)
      ? type == "make"
        ? order.make_name
        : order.model_name
      : type == "make"
      ? order.make
      : order.model;
  };

  const getActivePolicies = () => {
    let ordenesT = [];
    let daysLeft = 0;
    ordenes.forEach((order) => {
      status = calculateExpirationText(order.expiration_date);
      daysLeft = calculateExpirationDays(order.expiration_date);
      if (status != "Expired") {
        ordenesT.push([
          order.policy_nbr || "N/A",
          <>
            <span>
              {order.expiration_date || "N/A"}
              <span className={`${classesPrincipal.red}`}>
                {" "}
                ({daysLeft} {t("home.daysLeft")}){" "}
              </span>
            </span>

            <br />

            <Button
              type="submit"
              variant="greenHome"
              block
              onClick={() => {
                window.location.href = "/guest/en/" + order.order_id;
              }}
            >
              {t("home.needMoreDays")}
            </Button>
          </>,
          <b>
            {getMakeModelName(order, "make") || "N/A"}{" "}
            {getMakeModelName(order, "model") || "N/A"}
          </b>,
          <span className={`${classes.badge} ${classes.success}`}>
            {status}
          </span>,
          order.total,
          fillButtons(order),
        ]);
      }
    });
    return (
      <GridContainer>
        <GridItem xs={12} style={{ marginLeft: "20px" }}>
          <GridContainer style={{ marginBottom: "20px" }}>
            <GridItem xs={12}>
              <Table
                tableHead={[
                  t("home.policyNumber"),
                  t("home.expirationDate"),
                  t("home.vehicle"),
                  t("home.status"),
                  t("home.total"),
                  t("home.actions"),
                ]}
                tableData={ordenesT}
                customCellClasses={[
                  classes.center,
                  classes.right,
                  classes.right,
                ]}
                customClassesForCells={[0, 4, 5]}
                customHeadCellClasses={[
                  classes.center,
                  classes.right,
                  classes.right,
                ]}
                customHeadClassesForCells={[0, 4, 5]}
              />
            </GridItem>
          </GridContainer>
        </GridItem>
      </GridContainer>
    );
  };
  const focusWizard = () => {
    if (wizardRef.current) {
      setActiveStep(1);
      wizardRef.current.focusWizard(); // Llama al método del hijo
    }
  };
  const getExpiredPolicies = () => {
    let ordenesT = [];
    ordenes.forEach((order) => {
      status = calculateExpirationText(order.expiration_date);
      if (status == "Expired") {
        ordenesT.push([
          order.policy_nbr || "N/A",
          <>
            <span>{order.expiration_date || "N/A"}</span>

            <br />
            <Button
              type="submit"
              variant="greenHome"
              block
              onClick={() => {
                window.location.href = "/guest/en/" + order.order_id;
              }}
            >
              {t("home.buyAgain")}
            </Button>
          </>,
          <b>
            {getMakeModelName(order, "make") || "N/A"}{" "}
            {getMakeModelName(order, "model") || "N/A"}
          </b>,
          <span className={`${classes.badge} ${classes.danger}`}>
            {status}
          </span>,
          order.total,
          fillButtons(order),
        ]);
      }
    });

    return (
      <GridContainer>
        <GridItem xs={12} style={{ marginLeft: "20px" }}>
          <GridContainer style={{ marginBottom: "20px" }}>
            <GridItem xs={12}>
              <Table
                style={{ width: "100%" }}
                tableHead={[
                  t("home.policyNumber"),
                  t("home.expirationDate"),
                  t("home.vehicle"),
                  t("home.status"),
                  t("home.total"),
                  t("home.actions"),
                ]}
                tableData={ordenesT}
                customCellClasses={[
                  classes.center,
                  classes.right,
                  classes.right,
                ]}
                customClassesForCells={[0, 4, 5]}
                customHeadCellClasses={[
                  classes.center,
                  classes.right,
                  classes.right,
                ]}
                customHeadClassesForCells={[0, 4, 5]}
              />
            </GridItem>
          </GridContainer>
        </GridItem>
      </GridContainer>
    );
  };
  const getListQuotes = () => {
    let ordenesT = [];
    quotes.forEach((order) => {
      ordenesT.push([
        <>
          <span>{order.created_date || "N/A"}</span>
        </>,
        <b>
          {getMakeModelName(order, "make") || "N/A"}{" "}
          {getMakeModelName(order, "model") || "N/A"}
        </b>,
        completeQuote(order),
      ]);
    });
    return (
      <GridContainer>
        <GridItem xs={12} style={{ marginLeft: "20px" }}>
          <GridContainer style={{ marginBottom: "20px" }}>
            <GridItem xs={12}>
              <Table
                style={{ width: "100%" }}
                tableHead={[
                  t("home.createdDate"),
                  t("home.vehicle"),
                  t("home.actions"),
                ]}
                tableData={ordenesT}
                customCellClasses={[
                  classes.center,
                  classes.right,
                  classes.right,
                ]}
                customClassesForCells={[0, 4, 5]}
                customHeadCellClasses={[
                  classes.center,
                  classes.right,
                  classes.right,
                ]}
                customHeadClassesForCells={[0, 4, 5]}
              />
            </GridItem>
          </GridContainer>
        </GridItem>
      </GridContainer>
    );
  };

  const getActiveOrders = async () => {
    const resultSubmit = await dispatch(getActiveOrdersByClient());
    let countOrders = resultSubmit.payload.data.length;
    if (countOrders == 0) {
      setActiveStep(1);
    }
    setOrders(resultSubmit.payload.data);
  };
  const calculateExpiration = (orderExpirationDate) => {
    if (orderExpirationDate != null && orderExpirationDate != "") {
      const fechaActual = new Date();
      const fechaExpiracion = new Date(orderExpirationDate);
      const diferenciaMilisegundos = fechaExpiracion - fechaActual;
      const diferenciaDias = diferenciaMilisegundos / (1000 * 60 * 60 * 24);
      if (diferenciaDias <= 5) {
        return cardStyleExpire;
      } else if (diferenciaDias >= 6 && diferenciaDias <= 15) {
        return cardStyleWarning;
      } else if (diferenciaDias >= 16) {
        return cardStyleSuccess;
      }
    }
    return cardStyleExpire;
  };
  const calculateExpirationColor = (orderExpirationDate) => {
    if (orderExpirationDate != null && orderExpirationDate != "") {
      const fechaActual = new Date();
      const fechaExpiracion = new Date(orderExpirationDate);
      const diferenciaMilisegundos = fechaExpiracion - fechaActual;
      const diferenciaDias = diferenciaMilisegundos / (1000 * 60 * 60 * 24);
      if (diferenciaDias <= 5) {
        return "rose";
      } else if (diferenciaDias >= 6 && diferenciaDias <= 15) {
        return "warning";
      } else if (diferenciaDias >= 16) {
        return "success";
      }
    }
    return cardStyleExpire;
  };
  const handleWhatsApp = () => {
    const url = `https://wa.me/9566863601`;
    window.open(url);
  };
  const handleOpenSMSApp = () => {
    window.location.href = `sms:9566863601`;
  };
  const handleMakePhoneCall = () => {
    window.location.href = `tel:9566863601`;
  };
  const goToGoogleMaps = () => {
    window.open("https://maps.app.goo.gl/LWdzksnYxUcc2ZYBA");
  };
  const getAgencyData = async () => {
    const resultSubmit = await dispatch(getAgencyDataByClient());
    setAgencyData(resultSubmit.payload.data);
  };
  const classes = useStyles();

  // Hooks
  const [showActivePolicies, setActivePolicies] = React.useState(false);
  const [showAllPolicies, setAllPolicies] = React.useState(false);
  const redesign = process.env.REACT_APP_REDESIGN;
  const isRedesign = redesign === "true" ? true : false;
  const url = redesign === "true" ? "/guestRedesing" : "/admin/wizard";
  const ActivePoliciesComponent = () => getActivePolicies();
  const getOrdenesActive = (orders) => {
    let ordenes = [];
    orders.forEach((order) => {
      let status = calculateExpirationText(order.expiration_date);
      if (status != "Expired") {
        ordenes.push(order);
      }
    });
    return ordenes;
  };
  const getOrdenesExpired = (orders) => {
    let ordenes = [];
    orders.forEach((order) => {
      let status = calculateExpirationText(order.expiration_date);
      if (status == "Expired") {
        ordenes.push(order);
      }
    });
    return ordenes;
  };

  const homeCustomer = () => {
    return (
      <div className={classes.container}>
        <GridContainer justify="center">
          <GridItem xs={12} sm={12} md={12}>
            <GridContainer
              style={{ padding: "20px 0px 40px 0px" }}
              justify="center"
            >
              <GridContainer>
                <GridItem xs={12} md={7}>
                  <GridItem xs={12} sm={12} md={12} lg={12}>
                    <Card>
                      <CardHeader>
                        <div
                          className={`${classesPrincipal.subTitle} ${classesPrincipal.black}`}
                        >
                          {t("home.welcome")}{" "}
                        </div>
                        <div
                          className={`${classesPrincipal.title} ${classesPrincipal.black}`}
                        >
                          {t("home.needPolicy")}{" "}
                        </div>
                        <GridContainer>
                          <GridItem
                            xs={12}
                            md={4}
                            style={{ marginTop: "15px" }}
                          >
                            <Button
                              type="submit"
                              variant="green"
                              block
                              onClick={focusWizard}
                            >
                              {t("home.oldPolicy")}
                            </Button>
                          </GridItem>
                          <GridItem
                            xs={12}
                            md={4}
                            style={{ marginTop: "15px" }}
                          >
                            <Button
                              type="submit"
                              variant="green"
                              block
                              onClick={() => history.push(`/guest/en`)}
                            >
                              {t("home.newPolicy")}
                            </Button>
                          </GridItem>
                          <GridItem
                            xs={12}
                            md={4}
                            style={{ marginTop: "15px" }}
                          >
                            <Button
                              onClick={() => history.push(`/admin/resources`)}
                              type="submit"
                              variant="yellow"
                              block
                            >
                              {t("home.reportClaim")}
                            </Button>
                          </GridItem>
                        </GridContainer>
                      </CardHeader>
                    </Card>
                  </GridItem>
                </GridItem>
                {isXs || isSm ? null : (
                  <GridItem xs={12} md={5}>
                    <GridItem xs={12} sm={12} md={12} lg={12}>
                      {agencyData ? (
                        <Card>
                          <CardHeader>
                            <GridContainer>
                              {isXs || isSm ? null : (
                                <GridItem xs={12} md={2}>
                                  <StoreIcon></StoreIcon>
                                </GridItem>
                              )}
                              <GridItem xs={12} md={8}>
                                <div className={`${classesPrincipal.black}`}>
                                  {t("home.myAgent")}
                                </div>
                                <div
                                  className={`${classesPrincipal.font700} ${classesPrincipal.black}`}
                                >
                                  {agencyData.agency_name}
                                </div>
                                <p
                                  className={classes.cardCategory}
                                  style={{
                                    color: "#000000",
                                    textAlign: "left",
                                  }}
                                >
                                  {agencyData.address +
                                    " " +
                                    agencyData.city +
                                    ", " +
                                    agencyData.state_name +
                                    " " +
                                    agencyData.zipcode}
                                </p>
                              </GridItem>
                            </GridContainer>
                            <GridContainer>
                              <GridItem
                                xs={12}
                                md={4}
                                style={{ marginTop: "15px" }}
                              >
                                <span
                                  className={classesPrincipal.green}
                                  style={{
                                    cursor: "pointer",
                                    textDecoration: "underline",
                                  }}
                                >
                                  <PhoneIcon />
                                  {agencyData.phone}
                                </span>
                              </GridItem>

                              <GridItem
                                xs={12}
                                md={6}
                                style={{ marginTop: "15px" }}
                              >
                                <EmailIcon />
                                {agencyData.email}
                              </GridItem>
                            </GridContainer>
                          </CardHeader>
                          {(isXs || isSm) ?? (
                            <CardFooter stats>
                              <div className={classes.price}>
                                <Button
                                  justIcon
                                  round
                                  variant="greenW"
                                  style={{ marginRight: "7px" }}
                                  onClick={handleWhatsApp}
                                >
                                  <WhatsApp style={{ marginBottom: "10px" }} />
                                </Button>

                                <Button
                                  justIcon
                                  round
                                  variant="blue"
                                  style={{ marginRight: "7px" }}
                                  onClick={goToGoogleMaps}
                                >
                                  <Place style={{ marginBottom: "10px" }} />
                                </Button>
                              </div>
                            </CardFooter>
                          )}
                        </Card>
                      ) : null}
                    </GridItem>
                  </GridItem>
                )}
              </GridContainer>
              <GridContainer>
                <GridItem xs={12} md={7}>
                  <Wizard
                    ref={wizardRef}
                    activeStep={activeStep}
                    setActiveStep={setActiveStep}
                    steps={[
                      {
                        stepName: t("home.activePolicies"),
                        stepComponent: (
                          <div>
                            {isXs || isSm ? (
                              <PaginatedPoliciesMobile
                                orders={getOrdenesActive(ordenes)}
                                calculateExpirationText={
                                  calculateExpirationText
                                }
                                history={history}
                                server={server}
                                getMakeModelName={getMakeModelName}
                              />
                            ) : (
                              getActivePolicies()
                            )}
                          </div>
                        ),
                        color: "success",
                        stepId: "active",
                      },
                      {
                        stepName: t("home.expiredPolicies"),
                        stepComponent: (
                          <div>
                            {isXs || isSm ? (
                              <PaginatedPoliciesMobile
                                orders={getOrdenesExpired(ordenes)}
                                calculateExpirationText={
                                  calculateExpirationText
                                }
                                history={history}
                                server={server}
                                getMakeModelName={getMakeModelName}
                              />
                            ) : (
                              getExpiredPolicies()
                            )}
                          </div>
                        ),
                        color: "danger",
                        stepId: "expired",
                      },
                      {
                        stepName: t("home.savedQuotes"),
                        stepComponent: <div></div>,
                        stepId: "saved",
                        color: "warning",
                        stepComponent: (
                          <div>
                            {isXs || isSm ? (
                              <PaginatedPoliciesMobile
                                orders={quotes}
                                quoteType={true}
                                calculateExpirationText={
                                  calculateExpirationText
                                }
                                history={history}
                                server={server}
                                getMakeModelName={getMakeModelName}
                              />
                            ) : (
                              getListQuotes()
                            )}
                          </div>
                        ),
                      },
                    ]}
                  />
                </GridItem>
              </GridContainer>
              {isXs || isSm ? (
                <GridContainer>
                  <GridItem xs={12} md={5}>
                    <GridItem xs={12} sm={12} md={12} lg={12}>
                      {agencyData ? (
                        <Card>
                          <CardHeader>
                            <GridContainer>
                              {isXs || isSm ? null : (
                                <GridItem xs={12} md={2}>
                                  <StoreIcon></StoreIcon>
                                </GridItem>
                              )}
                              <GridItem xs={12} md={8}>
                                <div className={`${classesPrincipal.black}`}>
                                  {t("home.myAgent")}
                                </div>
                                <div
                                  className={`${classesPrincipal.font700} ${classesPrincipal.black}`}
                                >
                                  {agencyData.agency_name}
                                </div>
                                <p
                                  className={classes.cardCategory}
                                  style={{
                                    color: "#000000",
                                    textAlign: "left",
                                  }}
                                >
                                  {agencyData.address +
                                    " " +
                                    agencyData.city +
                                    ", " +
                                    agencyData.state_name +
                                    " " +
                                    agencyData.zipcode}
                                </p>
                              </GridItem>
                            </GridContainer>
                            <GridContainer>
                              <GridItem
                                xs={12}
                                md={4}
                                style={{ marginTop: "15px" }}
                              >
                                <span
                                  className={classesPrincipal.green}
                                  style={{
                                    cursor: "pointer",
                                    textDecoration: "underline",
                                  }}
                                >
                                  <PhoneIcon />
                                  {agencyData.phone}
                                </span>
                              </GridItem>

                              <GridItem
                                xs={12}
                                md={6}
                                style={{ marginTop: "15px" }}
                              >
                                <EmailIcon />
                                {agencyData.email}
                              </GridItem>
                            </GridContainer>
                          </CardHeader>
                          {(isXs || isSm) ?? (
                            <CardFooter stats>
                              <div className={classes.price}>
                                <Button
                                  justIcon
                                  round
                                  variant="greenW"
                                  style={{ marginRight: "7px" }}
                                  onClick={handleWhatsApp}
                                >
                                  <WhatsApp style={{ marginBottom: "10px" }} />
                                </Button>

                                <Button
                                  justIcon
                                  round
                                  variant="blue"
                                  style={{ marginRight: "7px" }}
                                  onClick={goToGoogleMaps}
                                >
                                  <Place style={{ marginBottom: "10px" }} />
                                </Button>
                              </div>
                            </CardFooter>
                          )}
                        </Card>
                      ) : null}
                    </GridItem>
                  </GridItem>
                </GridContainer>
              ) : null}
            </GridContainer>
          </GridItem>
        </GridContainer>
      </div>
    );
  };

  const homeAgent = () => {
    return (
      <div className={classes.container}>
        <GridContainer justify="center">
          <GridItem xs={12} sm={12} md={12}>
            <GridContainer
              style={{ padding: "20px 0px 40px 0px" }}
              justify="center"
            >
              <GridContainer>
                <GridItem xs={12} md={6}>
                  <GridItem xs={12} sm={12} md={12} lg={12}>
                    <Card>
                      <CardHeader>
                        <div
                          className={`${classesPrincipal.title} ${classesPrincipal.black}`}
                        >
                          {t("home.recentNews")}{" "}
                        </div>
                        <GridContainer>
                          <GridItem xs={12} style={{ marginTop: "15px" }}>
                            <Timeline>
                              {news.length > 0 && (
                                <TimelineItem>
                                  <TimelineOppositeContent
                                    style={{
                                      flexGrow: 1,
                                      flexShrink: 1,
                                      flexBasis: "0%",
                                      maxWidth: "20%",
                                    }}
                                  >
                                    {news[0].created}
                                  </TimelineOppositeContent>
                                  <TimelineSeparator>
                                    <Box
                                      sx={{
                                        width: 40,
                                        height: 40,
                                        borderRadius: "50%",
                                        overflow: "hidden",
                                        border: "2px solid #4CAF50",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        backgroundColor: "white",
                                      }}
                                    >
                                      <img
                                        src="https://agent.sanborns.com/assets/images/SanbornsLogo_bevel.png"
                                        alt="event"
                                        style={{
                                          width: "100%",
                                          height: "100%",
                                          objectFit: "cover",
                                        }}
                                      />
                                    </Box>
                                    <TimelineConnector />
                                  </TimelineSeparator>
                                  <TimelineContent>
                                    <h4>{news[0].title}</h4>
                                    <p>{news[0].brief}</p>
                                  </TimelineContent>
                                </TimelineItem>
                              )}
                            </Timeline>
                          </GridItem>
                        </GridContainer>
                      </CardHeader>
                    </Card>
                  </GridItem>
                </GridItem>
                <GridItem xs={12} md={6}>
                  <GridItem xs={12} sm={12} md={12} lg={12}>
                    <Card>
                      <CardHeader>
                        <div
                          className={`${classesPrincipal.title} ${classesPrincipal.black}`}
                        >
                          {t("home.monthDate")}{" "}
                        </div>
                        <GridContainer>
                          <GridItem xs={12} style={{ marginTop: "15px" }}>
                            {Array.isArray(dataMonth) && dataMonth.length > 0 && (
                              <div style={{ width: "100%", height: 400 }}>
                                <ResponsiveContainer width="100%" height="100%">
                                  <BarChart
                                    data={dataMonth}
                                    barCategoryGap="30%"
                                    margin={{
                                      top: 20,
                                      right: 30,
                                      left: 20,
                                      bottom: 30,
                                    }}
                                  >
                                    <CartesianGrid strokeDasharray="3 3" />
                                    <XAxis dataKey="name" />
                                    <YAxis />
                                    <Tooltip
                                      formatter={(value, name) => {
                                        if (name === "Net Premium") {
                                          return [
                                            `$${Number(value).toLocaleString(
                                              undefined,
                                              {
                                                minimumFractionDigits: 2,
                                                maximumFractionDigits: 2,
                                              }
                                            )}`,
                                            name,
                                          ];
                                        }
                                        return [value, name];
                                      }}
                                    />
                                    <Legend verticalAlign="top" />
                                    <Bar
                                      dataKey="policyCount"
                                      name="Policy Count"
                                      fill="rgba(255,0,0,0.5)"
                                      stroke="red"
                                      strokeWidth={2}
                                    />
                                    <Bar
                                      dataKey="netPremium"
                                      name="Net Premium"
                                      fill="rgba(0,128,0,0.5)"
                                      stroke="green"
                                      strokeWidth={2}
                                    />
                                  </BarChart>
                                </ResponsiveContainer>
                              </div>
                            )}
                          </GridItem>
                        </GridContainer>
                      </CardHeader>
                    </Card>
                  </GridItem>
                </GridItem>
              </GridContainer>
              <GridContainer>
                <GridItem xs={12} md={6}>
                  <GridItem xs={12} sm={12} md={12} lg={12}>
                    <Card>
                      <CardHeader>
                        <div
                          className={`${classesPrincipal.title} ${classesPrincipal.black}`}
                        >
                          {t("home.termPolicy")}{" "}
                        </div>
                        <GridContainer>
                          <GridItem xs={12} style={{ marginTop: "15px" }}>
                            <Table
                              tableHead={[
                                t("policies.policyNumber"),
                                {
                                  name: t("policies.firstName"),
                                  className:
                                    isXs || isSm || isMd
                                      ? classes.displayNone
                                      : "",
                                },
                                t("policies.expirationDate"),
                                {
                                  name: t("policies.status"),
                                  className:
                                    isXs || isSm || isMd
                                      ? classes.displayNone
                                      : "",
                                },
                              ]}
                              tableData={ordersExpiring}
                              customCellClasses={[
                                classes.center,
                                classes.right,
                                classes.right,
                              ]}
                              customClassesForCells={[0, 4, 5]}
                              customHeadCellClasses={[
                                classes.center,
                                classes.right,
                                classes.right,
                              ]}
                              customHeadClassesForCells={[0, 4, 5]}
                              rowsPerPage={10}
                              totalRows={ordersExpiring.length}
                            />
                          </GridItem>
                        </GridContainer>
                      </CardHeader>
                    </Card>
                  </GridItem>
                </GridItem>
                <GridItem xs={12} md={6}>
                  <GridItem xs={12} sm={12} md={12} lg={12}>
                    <Card>
                      <CardHeader>
                        <div
                          className={`${classesPrincipal.title} ${classesPrincipal.black}`}
                        >
                          {t("home.yearDate")}{" "}
                        </div>
                        <GridContainer>
                          <GridItem xs={12} style={{ marginTop: "15px" }}>
                            {Array.isArray(dataYear) && dataYear.length > 0 && (
                              <div style={{ width: "100%", height: 400 }}>
                                <ResponsiveContainer>
                                  <BarChart
                                    data={dataYear}
                                    barCategoryGap="30%"
                                    margin={{
                                      top: 20,
                                      right: 30,
                                      left: 20,
                                      bottom: 30,
                                    }}
                                  >
                                    <CartesianGrid strokeDasharray="3 3" />
                                    <XAxis dataKey="name" />
                                    <YAxis />
                                    <Tooltip />
                                    <Legend verticalAlign="top" />
                                    <Bar
                                      dataKey="policyCount"
                                      name="Policy Count"
                                      fill="rgba(255,0,0,0.5)"
                                      stroke="red"
                                      strokeWidth={2}
                                    />
                                    <Bar
                                      dataKey="netPremium"
                                      name="Net Premium"
                                      fill="rgba(0,128,0,0.5)"
                                      stroke="green"
                                      strokeWidth={2}
                                    />
                                  </BarChart>
                                </ResponsiveContainer>
                              </div>
                            )}
                          </GridItem>
                        </GridContainer>
                      </CardHeader>
                    </Card>
                  </GridItem>
                </GridItem>
              </GridContainer>
              <GridContainer>
                <GridItem xs={12} sm={12} md={12} lg={12}>
                  <Card>
                    <CardHeader>
                      <div
                        className={`${classesPrincipal.title} ${classesPrincipal.black}`}
                      >
                        {t("home.news")}{" "}
                      </div>
                      <GridContainer>
                        <GridItem xs={12} md={12} style={{ marginTop: "15px" }}>
                          <Timeline>
                            {news &&
                              news.map((newData) => (
                                <TimelineItem>
                                  <TimelineOppositeContent
                                    style={{
                                      flexGrow: 1,
                                      flexShrink: 1,
                                      flexBasis: "0%",
                                      maxWidth: "20%",
                                    }}
                                  >
                                    {newData.created}
                                  </TimelineOppositeContent>
                                  <TimelineSeparator>
                                    <Box
                                      sx={{
                                        width: 40,
                                        height: 40,
                                        borderRadius: "50%",
                                        overflow: "hidden",
                                        border: "2px solid #4CAF50",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        backgroundColor: "white",
                                      }}
                                    >
                                      <img
                                        src="https://agent.sanborns.com/assets/images/SanbornsLogo_bevel.png"
                                        alt="event"
                                        style={{
                                          width: "100%",
                                          height: "100%",
                                          objectFit: "cover",
                                        }}
                                      />
                                    </Box>
                                    <TimelineConnector />
                                  </TimelineSeparator>
                                  <TimelineContent>
                                    <h4>
                                      <a href={`/admin/new/${newData.id}`}>
                                        {newData.title}
                                      </a>
                                    </h4>
                                    <p>{newData.brief}</p>
                                  </TimelineContent>
                                </TimelineItem>
                              ))}
                          </Timeline>
                        </GridItem>
                      </GridContainer>
                    </CardHeader>
                  </Card>
                </GridItem>
              </GridContainer>
            </GridContainer>
          </GridItem>
        </GridContainer>
      </div>
    );
  };

  return (
    <>{localStorage.getItem("userType") == 3 ? homeCustomer() : homeAgent()}</>
  );
}
